import * as React from 'react';

const TagChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 11c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm3-7H4v8l8 8 8-8-8-8z"
        />
    </svg>
);

TagChunkySvg.displayName = 'TagChunkySvg';
export default TagChunkySvg;
